import * as yup from 'yup';

import { emailValidation } from '../emailValidation';
import { currentPasswordValidation } from '../passwordValidation';

export const loginSchema = yup.object().shape({
  email: emailValidation,
  password: currentPasswordValidation,
});
